import React from 'react';
import { CellRendererParams } from 'routes/BudgetModule/config/types';
import { useTranslation } from 'react-i18next';
import { MultiYearsComparisonRow } from 'routes/BudgetModule/components/BudgetOverview/BudgetSynthesisAndRatios/MultiYearsComparison/types';
import HeaderTooltip from 'routes/BudgetModule/components/BudgetOverview/BudgetSynthesisAndRatios/MultiYearsComparison/components/HeaderTooltip';

type Params = CellRendererParams<MultiYearsComparisonRow, string> & {
    colored: boolean;
};

export default function IndicatorNameCellRenderer({
    value,
    colored,
}: Params): React.ReactElement {
    const { t } = useTranslation();

    if (!value) {
        return <>...</>;
    }
    let tooltip = '';
    let displayInfoIcon = true;

    // if it falls into the following cases, we need to explain the value
    if (value === t('budgetOverview.cafBrut'))
        tooltip = t('budgetOverview.cafBrutDescription');
    else if (value === t('budgetOverview.cafNet'))
        tooltip = t('budgetOverview.cafNetDescription');
    else if (value === t('budgetOverview.excedentBrut'))
        tooltip = t('budgetOverview.excedentBrutDescription');
    else if (value === t('budgetOverview.cafBrutRatio'))
        tooltip = t('budgetOverview.cafBrutRatioDescription');
    else if (value === t('budgetOverview.cafNetRatio'))
        tooltip = t('budgetOverview.cafNetRatioDescription');
    else if (value === t('budgetOverview.excedentBrutRatio'))
        tooltip = t('budgetOverview.excedentBrutRatioDescription');
    else displayInfoIcon = false;

    return (
        <HeaderTooltip
            tooltip={tooltip}
            colored={colored}
            displayInfoIcon={displayInfoIcon}
            formattedValue={value}
            textAlign="left"
        />
    );
}
